import React, { Component } from 'react';
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
import { TextField  } from '@rmwc/textfield';
import Scrollbar from 'react-scrollbars-custom';
import {connect} from 'react-redux';
import { Select } from '@rmwc/select';
import * as actionCreator from "../../action/index.js"
import * as validate from './validations';
import Vertical from '../../assets/images/roof-style/regular.png';
import Tripplewidegarage from '../../assets/images/building-style/Triple_Wide _Garages.png';
import Concrete from '../../assets/images/installation/concrete.png';
class SaveLater extends React.Component {

render() {
   this.props.const_var.checkoutBtnDisabled = false;
    return (
       <div>
           <Modal show={this.props.isShowWhatThis} backdrop='static' keyboard={false} onHide={this.props.handleClose} dialogClassName= "what-this-modal react-modal"  backdropClassName="ract-modal-pre-parent" >   
           
            <button className="close" onClick={this.props.handleClose}><span className="icon-close"></span></button>
            <Modal.Body>    

            
                <div className="what-this-wrapper">
                  {(this.props.const_var.buildSizeHelpTextContent== true)
                    ?
                    <div className='build-size-detail'>
                    <div className='row'>
                    <div className='col-12'>
                    <h5 className="modal-title text-uppercase mb-4">BUILT & SIZE</h5>
               
               {/* <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

               <p>All the Lorem Ipsum generators on the Internet tend to repeat predefined chunk as necessary, making this the first true generator on the Internet.</p> */}
                    </div>
                    </div>
                    <div className='row building-box-type-1 mt-2'>
          <div className='col-6 col-sm-4 mt-4 mt-sm-0'>
            <div className='building-box-main-title'>
            Building Name
            </div>
            <div className='building-box-main-box'>
          <div className='building-box-img'>
      <img src={process.env.REACT_APP_BASE_URL+Tripplewidegarage} />
          </div>
          <div className='building-box-title'>
          Garage With Lean-to - <span>23 x 45 x 11</span>
          </div>
            </div>
            <div>

            </div>
          </div>

          <div className='col-6 col-sm-4 mt-4 mt-sm-0'>
            <div className='building-box-main-title'>
            Roof Style
            </div>
            <div className='building-box-main-box'>
          <div className='building-box-img'>
      <img src={process.env.REACT_APP_BASE_URL+Vertical} />
          </div>
          <div className='building-box-title'>
          Vertical
          </div>
            </div>
            <div>

            </div>
          </div>

          
          <div className='col-6 col-sm-4 mt-4 mt-sm-0'>
            <div className='building-box-main-title'>
            Installation Surface
            </div>
            <div className='building-box-main-box'>
          <div className='building-box-img'>
      <img src={process.env.REACT_APP_BASE_URL+Concrete} />
          </div>
          <div className='building-box-title'>
          Concrete
          </div>
            </div>
            <div>

            </div>
          </div>
      </div>

      <div className='row mt-4'>
      <div className='col-12'>
        <h6>Sub Heading</h6>

        <ul className='mt-4'>
          <li>Making this the first true generator</li>
          <li>It uses a dictionary of over 200 latin words.</li>
          <li>Generate lorem Ipsum which looks reasonable.</li>
        </ul>
      </div>
      </div>
                  </div>
                    : null
                  }
                  
     
      
           
              </div>
           
            
          </Modal.Body>
          
                 
        </Modal>
        </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}


export default connect(
  mapStoreToProps,
  actionCreator
)(SaveLater);